/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pl_History_Col_NoteInputs */

const vi_pl_history_col_note = /** @type {(inputs: Pl_History_Col_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phiếu`)
};

/**

* @param {Pl_History_Col_NoteInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pl_history_col_note = /** @type {((inputs?: Pl_History_Col_NoteInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pl_History_Col_NoteInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pl_history_col_note(inputs)
});